import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsReverseGeocodeResults extends SnModel {
  @Expose()
  public administrativeAreaLevel1: string;

  @Expose()
  public administrativeAreaLevel2: string;

  @Expose()
  public country: string;

  @Expose()
  public locality: string;

  @Expose()
  public postalCode: string;

  @Expose()
  public route: string;

  @Expose()
  public streetNumber: string;

  @Expose()
  public geometry: any;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }

  get address(): string {
    if (this.streetNumber || this.route) {
      return `${this.streetNumber} ${this.route}`;
    } else {
      return 'Address not available';
    }
  }
}
